export default "__VITE_ASSET__c3027a9d__"